export const validateForm = (formData) => {
  const errors = {};

  // Name validation
  if (!formData.name.trim()) {
    errors.name = "Name is required";
  }

  if (!formData.phone || formData.phone.trim().length < 1) {
    errors.phone = "Contact number is required.";
  } else if (!/^\d{1,15}$/.test(formData.phone)) {
    errors.phone =
      "Contact number must be a valid numeric value with up to 15 digits.";
  }

  // Email validation
  if (!formData.email.trim()) {
    errors.email = "Email is required";
  } else if (
    !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.email)
  ) {
    errors.email = "Enter a valid email address";
  }

  // Country validation
  if (formData.country === "0") {
    errors.country = "Please select a country";
  }

  // Subject validation
  if (!formData.subject.trim()) {
    errors.subject = "Subject is required";
  }

  // Description validation
  if (!formData.description.trim()) {
    errors.description = "Description is required";
  }

  return errors; // Return all errors
};
